import React, { FC, useState } from "react";
import { formatDistance, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import {
  EChatSetor,
  EChatType,
  getKeyFromValue,
  IChatGroup,
  IUser,
} from "@deltasge/marauders-map";

import {
  Avatar as MUIAvatar,
  Grid,
  IconButton,
  ListItem as MUIListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  Box,
  Badge,
} from "@mui/material";
import {
  AccountGroup as GroupIcon,
  DotsVertical as MenuIcon,
  Delete as DeleteIcon,
  ArchiveArrowDown as ArquivaIcon,
  ArchiveArrowUp as DesarquivarIcon,
} from "mdi-material-ui";

import { history } from "configs";
import { Avatar } from "components/Avatar";
import { useAppSelector } from "store";

export const ListItem: FC<{
  item: IChatGroup;
  divider?: boolean;
  user?: IUser;
  users: IUser[];
  handleChat: (args: {
    chat: IChatGroup;
    action: "archived" | "deleted";
    add?: boolean | undefined;
  }) => Promise<void>;
}> = ({ item, divider = false, handleChat, users, user }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const {
    usuario: { usuario },
    chat: { unreads: messages },
  } = useAppSelector((state) => state);

  const unread = (messages.find((f) => f._id == item._id)?.chats ?? []).length;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  let context = item.chats?.at(0)?.context;
  if (item.chats?.at(0)?.chatType == EChatType.Attachment)
    context = "Enviou um anexo";
  else if (item.chats?.at(0)?.chatType == EChatType.Audio)
    context = "Enviou um áudio";
  else if (item.chats?.at(0)?.chatType == EChatType.Video)
    context = "Enviou um vídeo";
  else if (item.chats?.at(0)?.chatType == EChatType.Image)
    context = "Enviou uma foto";
  else if (item.chats?.at(0)?.chatType == EChatType.Location)
    context = "Enviou uma localização";
  else if (item.chats?.at(0)?.chatType == EChatType.Sticker)
    context = "Enviou um sticker";

  return (
    <MUIListItem
      divider={divider}
      disablePadding
      secondaryAction={
        <Box>
          <IconButton onClick={handleClick}>
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                handleChat({ chat: item, action: "deleted", add: true });
              }}
            >
              <ListItemIcon>
                <DeleteIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Excluir</ListItemText>
            </MenuItem>
            {!!item.archived.find((f) => f.deltaId == usuario?.deltaId) && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  handleChat({ chat: item, action: "archived", add: false });
                }}
              >
                <ListItemIcon>
                  <DesarquivarIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Desarquivar</ListItemText>
              </MenuItem>
            )}
            {(!item.archived ||
              !item.archived.find((f) => f.deltaId == usuario?.deltaId)) && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  handleChat({ chat: item, action: "archived", add: true });
                }}
              >
                <ListItemIcon>
                  <ArquivaIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Arquivar</ListItemText>
              </MenuItem>
            )}
          </Menu>
        </Box>
      }
    >
      <ListItemButton onClick={() => history.push(`/chat/channel/${item._id}`)}>
        <ListItemAvatar>
          <Badge badgeContent={unread} color="secondary">
            {user && (
              <Avatar displayName={user.nome.rUpper()} src={user.photoUrl} />
            )}
            {!user && (
              <MUIAvatar>
                <GroupIcon />
              </MUIAvatar>
            )}
          </Badge>
        </ListItemAvatar>
        <Grid
          container
          sx={({ spacing }) => ({ width: `calc(100% - ${spacing(7)})` })}
        >
          <Grid item xs={8} zeroMinWidth>
            <Typography variant="body2" fontWeight={500} noWrap>
              {user && user.nome.rUpper()}
              {!user &&
                users
                  .map((m) =>
                    m.deltaId == usuario?.deltaId ? "Você" : m.nome.rUpper()
                  )
                  .join(", ")}
            </Typography>
          </Grid>
          <Grid item xs={4} textAlign="right" zeroMinWidth>
            {item.idSetor && (
              <Typography
                variant="caption"
                fontWeight={500}
                textAlign="right"
                component="p"
              >
                {getKeyFromValue(EChatSetor, item.idSetor)}
              </Typography>
            )}
          </Grid>
          <Grid item xs={8} zeroMinWidth>
            <Typography variant="caption" noWrap component="p">
              {context}
            </Typography>
          </Grid>
          <Grid item xs={4} textAlign="right" zeroMinWidth>
            <Typography variant="caption" noWrap component="p">
              {item.chats && item.chats[0].createdAt
                ? formatDistance(
                    parseISO(item.chats[0].createdAt.toString()),
                    new Date(),
                    {
                      addSuffix: true,
                      locale: ptBR,
                    }
                  )
                : ""}
            </Typography>
          </Grid>
        </Grid>
      </ListItemButton>
    </MUIListItem>
  );
};
